module.exports = __webpack_public_path__ + "img/C08TechIndrasGift_ua.4e1e343c.webp";